import cx from 'classnames';
import React from 'react';
import { useAppLayoutContext } from '../app-layout/app-layout-context.js';
import { NavItemGroup } from '../nav-item/index.js';
import { SideNavItem } from './side-nav-item.js';
import { SideNavItemTooltip } from './side-nav-item-tooltip.js';
export const SideNav = ({ className, sticky: externalSticky, variant, density: externalDensity, hasIcons, items, persistent, collapsed: externalCollapsed, onClick, onItemSelect, ...rest }) => {
    const density = (externalDensity !== null && externalDensity !== void 0 ? externalDensity : variant === 'internal') ? 'dense' : undefined;
    const sticky = externalSticky !== null && externalSticky !== void 0 ? externalSticky : variant === 'internal';
    if (persistent && !hasIcons) {
        console.warn('SideNav should only be `persistent` if `hasIcons` is also set');
    }
    // Look for an AppLayout by default
    const { navCollapsed } = useAppLayoutContext();
    const collapsed = externalCollapsed !== null && externalCollapsed !== void 0 ? externalCollapsed : navCollapsed;
    // If collapsed and set to persist as icons-only, show a tooltip with each item's text
    const showTooltip = collapsed && persistent;
    return (React.createElement("nav", { className: cx('tds-sidenav', {
            'tds-sidenav--sticky': sticky,
            [`tds-sidenav--${variant}`]: variant,
            [`tds-density--${density}`]: density,
            'tds-sidenav--icons': hasIcons,
            'tds-sidenav--persistent': persistent,
            'tds-sidenav--collapsed': collapsed,
        }, className), onClick: (e) => {
            if (onClick)
                onClick(e);
            if (onItemSelect) {
                const target = e.target;
                const item = (target === null || target === void 0 ? void 0 : target.localName) === 'button' ? target : target === null || target === void 0 ? void 0 : target.closest('button.tds-site-nav-item');
                onItemSelect((item === null || item === void 0 ? void 0 : item.id) || null);
            }
        }, ...rest },
        React.createElement(NavItemGroup, { layout: "vertical" }, items === null || items === void 0 ? void 0 : items.map((item, i) => showTooltip ? (React.createElement(SideNavItemTooltip, { key: item.id || i, item: item })) : (React.createElement(SideNavItem, { key: item.id || i, ...item }))))));
};
